import { RevealHeading, Reveal } from "../components/site/Reveal";
import { Medallion, OrnateDivider } from "../components/site/Ornaments";
import { GALLERY, whatsappLink } from "../data/site";

const spanClasses = {
  tall: "row-span-2 aspect-[3/4]",
  wide: "aspect-[4/3] sm:col-span-2",
  normal: "aspect-square",
};

const Gallery = () => {
  return (
    <div data-testid="gallery-page" className="pt-32">
      <section className="mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12">
        <div className="flex items-center gap-3 text-henna">
          <Medallion size={24} />
          <span className="text-xs uppercase tracking-[0.3em]">Selected work</span>
        </div>
        <RevealHeading
          testId="gallery-title"
          className="mt-6 max-w-4xl font-display text-6xl leading-[0.9] tracking-tight sm:text-7xl lg:text-8xl"
          lines={[<>The</>, <span className="italic font-serif text-henna">gallery</span>]}
        />
        <Reveal delay={0.4}>
          <p className="mt-8 max-w-xl text-base leading-relaxed text-ink/70">
            A glimpse of bridal palms, festive trails and the fine detail that
            keeps clients coming back season after season.
          </p>
        </Reveal>
      </section>

      <section className="mx-auto mt-16 max-w-[1400px] px-5 sm:px-8 lg:px-12">
        <div className="grid auto-rows-auto grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {GALLERY.map((g, i) => (
            <Reveal
              key={i}
              delay={(i % 3) * 0.08}
              className={`group relative overflow-hidden ${spanClasses[g.span]}`}
            >
              <img
                src={g.src}
                alt={g.label}
                data-testid={`gallery-img-${i}`}
                className="img-cover transition-transform duration-[900ms] ease-[cubic-bezier(0.19,1,0.22,1)] group-hover:scale-105"
              />
              <div className="pointer-events-none absolute inset-0 flex items-end bg-gradient-to-t from-ink/60 via-transparent to-transparent p-5 opacity-0 transition-opacity duration-500 group-hover:opacity-100">
                <span className="text-sm uppercase tracking-[0.15em] text-bone">
                  {g.label}
                </span>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="mx-auto max-w-[1400px] px-5 py-24 text-center sm:px-8 lg:px-12">
        <Reveal>
          <OrnateDivider className="mb-10" />
          <p className="mx-auto max-w-2xl font-display text-3xl leading-tight sm:text-4xl">
            Want your hands to look like this on your big day?
          </p>
          <a
            href={whatsappLink()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="gallery-book-btn"
            className="mt-8 inline-block rounded-full bg-henna px-8 py-4 text-xs uppercase tracking-[0.2em] text-bone transition-colors duration-300 hover:bg-ink"
          >
            Reserve your date
          </a>
        </Reveal>
      </section>
    </div>
  );
};

export default Gallery;
